import { render } from "./AddToBag.vue?vue&type=template&id=5fd2f07a"
import script from "./AddToBag.vue?vue&type=script&lang=js"
export * from "./AddToBag.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__